import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal } from "antd";

const StationDetailsList = (props) => {
    const { addForm, update,sId} = props;
    const [data, setData] = useState([]);

    const [itemsPerPage] = useState(10);
  
    const { sendRequest: deleteOperation } = useHttp();
  
    const handleDelete = (e, stationId) => {
      e.preventDefault();
      AntModal.confirm({
        title: "Confirm Deletion",
        content: "Are you sure you want to delete this station detail?",
        onOk() {
        
  
          deleteOperation(
            {
              url: `/api/station/?orgId=${localStorage.getItem(
                "orgId"
              )}&stationId=${stationId}&serviceId=${serviceId}`,
              method: "DELETE",
            },
            (data) => {
              if (data.success) {
                toast.success(data.success);
              }
         
              if (data.error) {
                toast.error(data.error);
              }
              FillDetail();
            }
          );
        },
        onCancel() {},
      });
    };
  
    const { sendRequest: getstationData } = useHttp();
  
    const FillDetail = () => {
      getstationData(
        {
          url: `/api/station/?orgId=${localStorage.getItem("orgId")}`,
        },
        (res) => {
          if (res) {
            setData(res);
            setAllData(res);
          //  console.log(res);
          }
        }
      );
    };
  
    useEffect(() => {
      FillDetail();
    }, [getstationData]);
  
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  
    const paginate = (pageNumber) => {
      setCurrentPage(pageNumber);
    };
  
  
    const [canAdd, setCanAdd] = useState("none");
    const [canEdit, setCanEdit] = useState("none");
    const [canDelete, setCanDelete] = useState("none");
    const [canPdf, setCanPdf] = useState("none");
    const [canView, setCanView] = useState("none");
    const [serviceId, setServiceId] = useState("none");
  
    useEffect(() => {
      var urlpathname = window.location.pathname;
      var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));
  
      if (roleAllocation && roleAllocation.length > 0) {
        //console.log("roleAllocation", roleAllocation);
  
        var roleAllocationFilterList = roleAllocation.filter(
          (item) => item.serviceUrl == urlpathname
        );
        //console.log("roleAllocationFilterList", roleAllocationFilterList);
        if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
          var itemselected = roleAllocationFilterList[0];
  
          console.log(itemselected);
  
          setServiceId(itemselected.serviceId);
          if (itemselected.canAddStatus == true) {
            setCanAdd("block");
          }
  
          if (itemselected.canEditStatus == true) {
            setCanEdit("block");
          }
  
          if (itemselected.canDeleteStatus == true) {
            setCanDelete("block");
          }
          if (itemselected.canViewStatus == true) {
            setCanView("block");
          }
  
          if (itemselected.canPdfStatus == true) {
            setCanPdf("block");
          }
          //console.log("canAdd", canAdd);
        }
      }
    }, []);

    const [allData, setAllData] = useState([]);

    const handleSearch = (e) => {
     
        var filetrtext = e.target.value.trim().toLowerCase();
  
      var filterdata = allData.filter(
        (item) =>
          item.regionName.toLowerCase().includes(filetrtext) ||
          item.stationName.toLowerCase().includes(filetrtext) ||
          item.stationCode.toLowerCase().includes(filetrtext)
      );
  
     setData(filterdata); 
                                
setCurrentPage(1);
    };
  
    return (
      <>
        <div className="content-wrapper">
          <div className="row mx-2">
            <div className="col-9">
              <label className="card-title  my-3">
                {" "}
                &nbsp; &nbsp;Station Details{" "}
              </label>{" "}
            </div>
  
            <div className="col-3 text-right">
              <button
                type="button"
                className="btn  btn-primary my-2"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Station Details
              </button>
            </div>
          </div>
  
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-5"> </div>
                        <div className="col-4"> </div>
  
                        <div className="col-3">
                          {" "}
                          <input
                            type="text"
                            name="q"
                            className="form-control"
                            placeholder="Search..."
                            onKeyUp={(e) => {
                              handleSearch(e);
                            }}
                          />{" "}
                          <br />
                        </div>
                      </div>
                      <div className="row">
                        <table className="table table-bordered text-center">
                          <thead>
                            <tr>
                              <th>Station Name</th>
                              <th>Station Code</th>
                          
                              <th>Region Name</th>
                              <th>Edit</th>
                              <th>Delete</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems &&
                              currentItems.map((x, i) => (
                                <tr key={i}>
                                  <td>{x.stationName}</td>
                                  <td>{x.stationCode}</td>
                               
  
                                  <td>
                                    {x.regionName}
                                  </td>
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => {
                                        props.update(x);
                                        sId(serviceId);
                                        props.addForm(true);
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  </td>
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={(e) => handleDelete(e, x.stationId)}
                                    >
                                      {" "}
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* /.card-body */}
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  };

export default StationDetailsList